export const splitAndTrim = (value: string, splitChar: string = ",") => {
    if (!value) {
        return [];
    }
    return value.split(splitChar).map((val: string) => val.trim());
}
// Gibt entweder den übergebenen Wert zurück oder einen leeren String aber niemals undefined oder null
export const initializeWithFallback = (value?: string) => {
    return value ? value : '';
}